import { useHistory } from "react-router-dom";

// Components
import Welcome from "./Welcome";

const WelcomeContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * End Hooks
     */

    return <Welcome {...props} history={history} />;

};

export default WelcomeContainer;
